// extracted by mini-css-extract-plugin
export var actionButton = "_ja-t";
export var buttonContainer = "_ja-0";
export var buttonContainer2 = "_ja-1";
export var buttonSection = "_ja-2";
export var details = "_ja-3";
export var dropdownItem = "_ja-5";
export var dropdownItemsContainer = "_ja-4";
export var fileInput = "_ja-r";
export var headerButton = "_ja-6";
export var icon = "_ja-7";
export var input = "_ja-8";
export var macroListItem = "_ja-9";
export var mainContent = "_ja-a";
export var microText = "_ja-b";
export var modal = "_ja-w";
export var optionsButton = "_ja-c";
export var paperclip = "_ja-s";
export var pillContent = "_ja-d";
export var preview = "_ja-e";
export var preview2 = "_ja-f";
export var quillEditor = "_ja-q";
export var selectedMacro = "_ja-g";
export var sidebar = "_ja-h";
export var sidebarHeader = "_ja-j";
export var sidebarList = "_ja-i";
export var sidebarListItem = "_ja-k";
export var sidebarSearch = "_ja-l";
export var snoozeDurationWrapper = "_ja-v";
export var statusPillContainer = "_ja-m";
export var tagsContainer = "_ja-n";
export var unselectedMacro = "_ja-o";
export var variable = "_ja-u";
export var wrapper = "_ja-p";